import {
  getBoxShadowStyle,
  getDraggablePopupBackgroundStyle,
  getOverlayStyle,
  getOuterBorderStyle,
} from "../helper";
import { getStaticCartDrawerSteps } from "../constants/custom-cart-drawer-template";
import {
  readCartDrawerDesignTokens,
  resolveCartDrawerSideMarginPx,
} from "../../shared/cart-drawer-design-tokens.js";

function formatCssSize(value, unit = "px") {
  if (value === "" || value == null) return undefined;
  if (typeof value === "string" && /%|px|em|rem|vh|vw/i.test(value)) {
    return value;
  }
  const num = Number(value);
  if (!Number.isFinite(num)) return String(value);
  return `${num}${unit || "px"}`;
}

/** Dim overlay used by custom cart template (not in legacy getOverlayStyle switch). */
function getCartDrawerOverlayStyle(overlayStyle) {
  // if (overlayStyle === "Dim") {
  //   return {
  //     backgroundColor: "rgba(15, 23, 42, 0.45)",
  //     backdropFilter: "blur(2px)",
  //   };
  // }
  // return getOverlayStyle(overlayStyle);
}

/**
 * Maps Website Overlay / popupSettings to inline styles for the static cart drawer shell.
 */
export function getStaticCartDrawerShellStyles(popupData, isMobile) {
  const schema = Array.isArray(popupData?.schema) ? popupData.schema : [];
  const { drawerStepIndex } = getStaticCartDrawerSteps(popupData);
  const step =
    drawerStepIndex != null ? schema[drawerStepIndex] : schema[0] ?? null;
  const popupSettings = step?.popupSettings || {};
  const dynamicalOptions = popupSettings.dynamicalOptions || {};
  const viewport = isMobile ? "mobile" : "desktop";
  const customCSS = popupSettings.customCSS?.[viewport] || {};

  const padding = Number(dynamicalOptions.window?.padding?.[viewport]) || 0;
  const zIndexRaw = Number(popupSettings.zIndex);
  const zIndex =
    Number.isFinite(zIndexRaw) && zIndexRaw > 0
      ? Math.min(Math.round(zIndexRaw), 2147483647)
      : 2147483647;

  const hideBackdrop = dynamicalOptions.isHideBgOverlay === true;
  const overlayStyleName = dynamicalOptions.overlay_style || "Dim";
  const overlayIsNone = overlayStyleName === "None";

  const width = formatCssSize(customCSS.width, customCSS.widthUnit || "px");
  const height = formatCssSize(customCSS.height, customCSS.heightUnit || "%");

  const showBackground = customCSS.showBackground !== false;
  const design = readCartDrawerDesignTokens(
    step?.cartDrawerLayout,
    popupSettings
  );

  // Outer panel uses shellCornerRadius; buttons use design.cornerRadius separately.
  const borderRadius = `${design.shellCornerRadius}px`;

  // Desktop float inset from Design; mobile stays edge-to-edge.
  const floatInsetPx = resolveCartDrawerSideMarginPx(design, isMobile);
  const resolvedHeight =
    !height || height === "100%"
      ? floatInsetPx > 0
        ? `calc(100% - ${floatInsetPx * 2}px)`
        : "100%"
      : height;

  const panelStyle = {
    width: width || (isMobile ? "100%" : "420px"),
    maxWidth: "100%",
    height: resolvedHeight,
    maxHeight: resolvedHeight,
    margin: floatInsetPx > 0 ? `${floatInsetPx}px` : "0",
    marginLeft: "auto",
    flexShrink: 0,
    borderRadius,
  };

  const backgroundColor =
    design.backgroundColor || customCSS.backgroundColor || "#ffffff";

  if (showBackground) {
    Object.assign(
      panelStyle,
      {
        backgroundColor,
      },
      getDraggablePopupBackgroundStyle(popupSettings, isMobile)
    );
  } else {
    panelStyle.backgroundColor = "transparent";
    panelStyle.backgroundImage = "none";
  }

  const borderColor =
    design.borderColor || customCSS.borderColor || "#e3e3e3";
  const borderWidth =
    customCSS.borderWidth != null ? Number(customCSS.borderWidth) : 1;
  if (Number.isFinite(borderWidth) && borderWidth > 0) {
    panelStyle.border = `${borderWidth}px ${
      customCSS.borderStyle || "solid"
    } ${borderColor}`;
  } else {
    panelStyle.border = `1px solid ${borderColor}`;
  }

  const rootStyle = {
    zIndex,
    position: "fixed",
    inset: 0,
    padding: padding > 0 ? `${padding}px` : undefined,
    boxSizing: "border-box",
  };

  const backdropStyle = {
    ...getCartDrawerOverlayStyle(overlayStyleName),
    pointerEvents: overlayIsNone ? "none" : "auto",
  };

  const panelBackgroundColor =
    showBackground && !panelStyle.backgroundImage
      ? panelStyle.backgroundColor || "#ffffff"
      : undefined;

  return {
    rootStyle,
    panelStyle,
    panelBackgroundColor,
    backdropStyle,
    hideBackdrop: hideBackdrop || overlayIsNone,
    overlayStyleName,
  };
}
